<template>
  <div class="text-center">
    <v-row dense>
      <v-col xs="12" sm="12" md="12" lg="12">
        <v-tooltip
          bottom
          :key="key"
          max-width="300"
          v-for="key in Object.keys(statisticsKeys)"
        >
          <template v-slot:activator="{ on }">
            <v-row dense v-on="on" class="pl-4 pr-4 statistic-row">
              <v-col align="left" class="pa-0 ma-0" xs="5" sm="5" md="5" lg="5">
                <h5>
                  {{ statisticsKeys[key].title }} ({{
                    statisticsKeys[key].value
                  }})
                </h5>
              </v-col>
              <v-col
                class="pa-0 ma-0 d-flex align-center"
                xs="7"
                sm="7"
                md="7"
                lg="7"
              >
                <v-progress-linear
                  height="10"
                  :value="statisticsKeys[key].percent"
                  :color="statisticsKeys[key].color"
                  :buffer-value="statisticsKeys[key].percent"
                  striped
                />
              </v-col>
            </v-row>
          </template>
          <span>{{ statisticsKeys[key].tooltip }}</span>
        </v-tooltip>
        <template v-if="matchScoreStatistics">
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <v-row dense v-on="on" class="pl-4 pr-4 statistic-row">
                <v-col
                  align="left"
                  class="pa-0 ma-0"
                  xs="5"
                  sm="5"
                  md="5"
                  lg="5"
                >
                  <h5>
                    Match scores ({{ matchScoreStatistics.matchesAmount }})
                  </h5>
                </v-col>
                <v-col
                  class="pa-0 ma-0 d-flex align-center"
                  xs="7"
                  sm="7"
                  md="7"
                  lg="7"
                >
                  <v-progress-linear
                    :value="matchScoreStatistics.matchesAmount"
                    :color="'#5eb319'"
                    :buffer-value="matchScoreStatistics.matchesAmount"
                    height="10"
                    striped
                  />
                </v-col>
              </v-row>
            </template>
            <span>Results that have Match Score as a green smiley face</span>
          </v-tooltip>
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <v-row dense v-on="on" class="pl-4 pr-4 statistic-row">
                <v-col
                  align="left"
                  class="pa-0 ma-0"
                  xs="5"
                  sm="5"
                  md="5"
                  lg="5"
                >
                  <h5>
                    Multi-match scores ({{
                      matchScoreStatistics.multimatchWithMatches
                    }})
                  </h5>
                </v-col>
                <v-col
                  class="pa-0 ma-0 d-flex align-center"
                  xs="7"
                  sm="7"
                  md="7"
                  lg="7"
                >
                  <v-progress-linear
                    :value="matchScoreStatistics.multimatchWithMatches"
                    :color="'#027205'"
                    :buffer-value="matchScoreStatistics.multimatchWithMatches"
                    height="10"
                    striped
                  />
                </v-col>
              </v-row>
            </template>
            <span>
              Multi-match results that have Match Score as a green smiley face
            </span>
          </v-tooltip>
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <v-row dense v-on="on" class="pl-4 pr-4 statistic-row">
                <v-col
                  align="left"
                  class="pa-0 ma-0"
                  xs="5"
                  sm="5"
                  md="5"
                  lg="5"
                >
                  <h5>Total revenue ({{ totalRevenue }}%)</h5>
                </v-col>
                <v-col
                  class="pa-0 ma-0 d-flex align-center"
                  xs="7"
                  sm="7"
                  md="7"
                  lg="7"
                >
                  <v-progress-linear
                    :value="totalRevenue"
                    :color="'#027205'"
                    :buffer-value="100"
                    height="10"
                    striped
                  />
                </v-col>
              </v-row>
            </template>
            <span>Sum of the revenue percentage of all items</span>
          </v-tooltip>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'FileStatistics',
  props: {
    stats: {
      type: Object,
      default: () => ({
        rows: {}
      })
    },
    matchScoreStatistics: {
      type: Object,
      default: null
    },
    revenue: {
      type: Number,
      default: 0
    }
  },
  watch: {
    stats: {
      deep: true,
      handler() {
        this.calculateStats();
      }
    }
  },
  data() {
    return {
      succeeded: {
        persent: 0,
        value: 0
      },
      failed: {
        persent: 0,
        value: 0
      },
      not_reviewedPercent: {
        persent: 0,
        value: 0
      },
      not_reviewed: {
        persent: 0,
        value: 0
      },
      readyToImport: {
        persent: 0,
        value: 0
      },
      statisticsKeys: {
        succeeded: {
          title: 'Imported',
          color: '#7DAC1E',
          persent: 0,
          value: 0,
          reducerKeys: ['imported'],
          tooltip: "Only rows with 'Imported' status "
        },
        readyToImport: {
          title: 'Ready for import',
          color: '#5A98B1',
          persent: 0,
          value: 0,
          reducerKeys: ['ready_for_import'],
          tooltip: "Only rows with 'Ready for import' status "
        },
        customerFaced: {
          title: 'Ask Customer (A)',
          color: '#E06C00',
          persent: 0,
          value: 0,
          reducerKeys: ['ask_customer'],
          tooltip:
            'The summary of rows with the next statuses: \ncustomer_requested + ask_customer'
        },
        // failed: {
        //   title: "Unmatched",
        //   color: "#D7574A",
        //   persent: 0,
        //   value: 0,
        //   reducerKeys: ["unmatched"],
        //   tooltip: "Only rows with 'Unmatched' status "
        // },
        needs_change: {
          title: 'Needs change (X)',
          color: '#D7574A',
          persent: 0,
          value: 0,
          reducerKeys: ['needs_change', 'needs_code_change'],
          tooltip:
            "Only rows with 'Needs change (X)' and 'Needs code change (X)' statuses"
        },
        not_reviewed: {
          title: 'Not reviewed',
          color: '#ECE4D9',
          persent: 0,
          value: 0,
          reducerKeys: ['not_reviewed'],
          tooltip: "Only rows with 'Not reviewed' status "
        },
        ignored: {
          title: 'Ignored',
          color: '#9F9B9B',
          persent: 0,
          value: 0,
          reducerKeys: [
            'ignore',
            'ignore_by_multimatch',
            'ignore_by_customer',
            'no_multimatch'
          ],
          tooltip:
            'The summary of rows with the next statuses: Ignore (I) + Ignore by customer (IC) + NO Multimatch (N)'
        }
      },
      total: {
        value: 0,
        reducerKeys: [
          'ready_for_import',
          'ask_customer',
          'customer_requested',
          'needs_change',
          'needs_code_change',
          'ignore',
          'imported',
          'not_reviewed',
          'ignore_by_multimatch',
          'ignore_by_customer',
          'needs_re_review',
          'supply',
          'unmatched',
          'no_multimatch',
          'compounded'
        ]
      }
    };
  },
  computed: {
    totalRevenue() {
      return (this.revenue || 0).toFixed(2);
    }
  },
  created() {
    setTimeout(() => {
      this.calculateStats();
    }, 500);
  },

  methods: {
    calculateStats() {
      this.total.value = this.total.reducerKeys.reduce(
        (accumulator, currentValue) => accumulator + this.stats[currentValue],
        0
      );

      Object.keys(this.statisticsKeys).forEach(this.calculatePercent);
    },
    calculatePercent(key) {
      const keyData = this.statisticsKeys[key].reducerKeys.reduce(
        (accumulator, currentValue) => accumulator + this.stats[currentValue],
        0
      );
      this.statisticsKeys[key].value = keyData;
      if (this.total.value === 0) return;

      this.$set(
        this.statisticsKeys[key],
        'percent',
        Math.round((keyData / this.total.value) * 100)
      );
    }
  },
  mounted() {}
};
</script>

<style scoped>
.statistic-row {
  margin-bottom: 4px;
}
</style>
